"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _commonCta = require("@mmc/common-cta");
var _editorialContentGrid = _interopRequireDefault(require("../styles/editorial-content-grid.css"));
var _editorialContentGrid2 = _interopRequireDefault(require("./editorial-content-grid.props/editorial-content-grid.defaultProps"));
var _editorialContentGrid3 = _interopRequireDefault(require("./editorial-content-grid.props/editorial-content-grid.propTypes"));
var dataUtils = new _mmcDataUtilities["default"]();
var handleNestedProp = dataUtils.handleNestedProp;
var linkData = function linkData(link) {
  return {
    label: handleNestedProp(link, 'link.label'),
    url: handleNestedProp(link, 'link.url'),
    priority: handleNestedProp(link, 'link.priority'),
    openNewTab: handleNestedProp(link, 'link.openNewTab'),
    icon: handleNestedProp(link, 'link.icon')
  };
};
var CtaWrapper = function CtaWrapper(_ref) {
  var link = _ref.link,
    theme = _ref.theme;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _editorialContentGrid["default"].ctaWrapper
  }, /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
    theme: theme,
    data: linkData(link)
  }));
};
CtaWrapper.displayName = 'CtaWrapper';
CtaWrapper.defaultProps = {
  link: _editorialContentGrid2["default"].columns[0].link
};
var _default = CtaWrapper;
exports["default"] = _default;